/**
 * src/help/seenStore.web.ts — WEB coachmark "seen" persistence (WO-H1).
 *
 * Uses localStorage (non-PII flag). SSR-safe: guards `window`/`localStorage` so a server
 * render (or a locked-down browser) degrades to "nothing seen yet" without throwing.
 *
 * NEVER imports @smartbox/* (mobile invariant 1).
 */
const KEY = 'beam_help_seen_flows';

function ls(): Storage | null {
  try {
    if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
  } catch {
    // access can throw in privacy modes
  }
  return null;
}

export async function getSeenFlows(): Promise<string[]> {
  const store = ls();
  if (!store) return [];
  try {
    const raw = store.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export async function markFlowSeen(flowKey: string): Promise<void> {
  const store = ls();
  if (!store) return;
  try {
    const current = await getSeenFlows();
    if (current.includes(flowKey)) return;
    store.setItem(KEY, JSON.stringify([...current, flowKey]));
  } catch {
    // best-effort
  }
}

export async function resetSeenFlows(): Promise<void> {
  const store = ls();
  if (!store) return;
  try {
    store.removeItem(KEY);
  } catch {
    // ignore
  }
}
